export default "__VITE_ASSET__BKU$NRBZ__"